import isEmpty from "lodash/isEmpty";

import Typo from "~/components/atoms/Typo";
import CardProject from "~/components/molecules/CardProject";
import { IProject } from "~/entities/project";
import { ETypoColor } from "~/utilities/enums/Colors";
import { ETypoTag, ETypoVariant } from "~/utilities/enums/Typo";

export interface CuratedPropertiesProps {
  title: string;
  projects: IProject[];
  handleOnSelectProject?: () => void;
}

export default function CuratedProperties({
  title,
  projects,
  handleOnSelectProject,
}: CuratedPropertiesProps) {
  return (
    <section className="flex flex-col items-center justify-center gap-12 bg-curatedPropertiesBackground py-12 lg:hidden">
      <Typo
        color={ETypoColor.CURATED_PROPERTIES_HEADING}
        className="font-bold lg:text-sub-title-20 lg:font-bold"
        tag={ETypoTag.H3}
        variant={ETypoVariant.HEADER_36}
      >
        {title}
      </Typo>
      <div className="container grid grid-cols-4 gap-6 xxl:grid-cols-3">
        {!isEmpty(projects) &&
          projects.map((project, index) => (
            <CardProject
              key={project.id + index}
              className="h-auto"
              thumbnailClass="min-h-[136px]"
              handleOnSelectProject={handleOnSelectProject}
              project={project}
            />
          ))}
      </div>
    </section>
  );
}
